var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Consistency analysis"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.rm
                    ? _c("h3", { staticClass: "text-center" }, [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading..."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rm
                    ? _c("div", [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "collapse",
                            attrs: { id: "consistencyAnalysisLegend" },
                          },
                          [_c("ConsistencyAnalysisLegend")],
                          1
                        ),
                        _vm._v(" "),
                        _c("table", { staticClass: "table mt-3" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.contexts, function (c) {
                              return _c("tr", { key: c.CriterionId }, [
                                _c(
                                  "td",
                                  [
                                    _c("ConsistencyAnalysisCircles", {
                                      attrs: { status: c.Status },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _c("span", [_vm._v(_vm._s(c.CriterionName))]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(_vm._s(c.CriterionPath)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "px-0" }, [
                                  c.CR != null
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress",
                                          staticStyle: { height: "30px" },
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "progress-bar text-dark",
                                            class: _vm.getCssClass(c.Status),
                                            style: { width: c.CR + "%" },
                                            attrs: { role: "progressbar" },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  c.CR == null
                                    ? _c(
                                        "span",
                                        { staticClass: "font-italic" },
                                        [
                                          _vm._v(
                                            "\n                                            Insufficient data\n                                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  c.CR != null
                                    ? _c("span", [_vm._v(_vm._s(c.CR) + "%")])
                                    : _vm._e(),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: c.CriterionUrl,
                                          expression: "c.CriterionUrl",
                                        },
                                      ],
                                      staticClass: "btn btn-outline-secondary",
                                    },
                                    [_vm._v("Review")]
                                  ),
                                ]),
                              ])
                            }),
                            0
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h6", { staticClass: "bg-light p-2 border mb-0" }, [
      _c(
        "a",
        {
          staticClass: "text-dark",
          attrs: {
            "data-toggle": "collapse",
            "data-target": "#consistencyAnalysisLegend",
            role: "button",
          },
        },
        [
          _c("i", {
            staticClass: "fa fa-question-circle-o",
            attrs: { "aria-hidden": "true" },
          }),
          _vm._v(" What is inconsistency score?\n                            "),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", { staticStyle: { width: "50px" } }),
        _vm._v(" "),
        _c("th", [_vm._v("Context")]),
        _vm._v(" "),
        _c("th", { staticClass: "px-0" }, [_vm._v("Inconsistency score")]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "50px" } }),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }